const userProfile = {
    userProfile: {
        caption: 'Mi perfil',
    }
};

export default userProfile;